import React from "react";

//import Link
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section id="about" className="bg-[#f8f3ec] py-280 relative">
      <div className="bg-white py-24 px-6">
        {/* Floating Card */}
        <div
          className="
          bg-[#f8f3ec] 
          rounded-3xl 
          shadow-[0_8px_30px_rgba(0,0,0,0.08)] 
          border border-accent/20 
          p-10 lg:p-14 
          max-w-5xl 
          mx-auto
        "
        >
          {/* Title with Icon */}
          <div className="flex items-center justify-center gap-3 mb-3">
            <h2 className="text-3xl font-extrabold text-primary tracking-wide text-center">
              About Cire Legal
            </h2>
          </div>

          {/* Introduction */}
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            At Cire Legal, we assist clients in all manner of business-related
            legal matters. We represent start-ups, entrepreneurs, business
            owners, and nonprofit organizations seeking clear legal guidance and
            long-term strategic support. Our firm believes a successful attorney
            client relationship is built on collaboration, transparency, and a
            deep understanding of your goals.
          </p>

          {/* Chi Chi Bio */}
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            Chi Chi Anachebe Louis is the Founder and Managing Attorney of Cire
            Legal. She helps entrepreneurs, professionals, and small businesses
            protect their brands and navigate complex legal issues with clarity
            and confidence. A former BigLaw litigator, legal recruiter, and
            enterprise sales executive, she brings over a decade of combined
            experience across law, business strategy, and client relations.
          </p>

          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            Her practice spans employment law, contract drafting and
            negotiation, intellectual property, business formation, NIL
            strategy, licensing, and estate planning. Known for her practical,
            empathetic approach, Chi Chi combines sharp legal analysis with
            real-world insight empowering clients to make informed, strategic
            decisions.
          </p>

          <p className="text-gray-600 text-lg leading-relaxed">
            Chi Chi earned her J.D. from Mississippi College School of Law and
            her B.A. from Auburn University. She is a proud member of the State
            Bar of Georgia, the Georgia Association of Black Women Attorneys,
            and Delta Sigma Theta Sorority, Inc.
          </p>

          {/* Practice Areas — Modern Grid List */}
          <div className="mt-10 mb-12">
            <h3 className="text-3xl font-semibold text-primary mb-6">
              How We Support Your Business:
            </h3>

            <ul className="grid sm:grid-cols-2 gap-3 text-lg text-gray-700 leading-relaxed">
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Business
                Formation
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Business
                Litigation (Consultation & Strategy Guidance)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Contract
                Preparation
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Contract
                Negotiation
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Employment
                Contracts
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Independent
                Contractor Agreements
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Non-Disclosure
                Agreements (NDAs)
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent text-xl">•</span> Business Real
                Estate Matters
              </li>
            </ul>
          </div>

          {/* Link/Button to Services section */}
          <div className="flex justify-center mb-8">
            <Link
              to="services"
              className="inline-block bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-md transition-all duration-300 cursor-pointer"
            >
              View Our Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
